import { orderProductList} from 'api/orderProduct';
import Cookies from 'js-cookie';

const orderProduct = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        orderProductList({commit},params) {
            return new Promise((resolve, reject) => {
                var productId = params.productId;
                var productName = params.productName;
                var psize = params.psize;
                var currentPage = params.currentPage;
                orderProductList(productId,productName, psize, currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default orderProduct;



// WEBPACK FOOTER //
// ./src/store/modules/orderProduct.js